import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { UserIcon, MailIcon, LockIcon, EyeIcon, EyeOffIcon, PhoneIcon } from 'lucide-react';
export function Signup() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle signup logic here
    console.log({
      fullName,
      email,
      phone,
      password,
      confirmPassword,
      agreeTerms
    });
  };
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-1129">
      <Header data-id="element-1130" />
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-1131">
        <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md" data-id="element-1132">
          <div className="text-center" data-id="element-1133">
            <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-1134">
              Create an account
            </h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-1135">
              Join Sunton Florist and enjoy our fresh flower delivery service
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-1136">
            <div className="rounded-md shadow-sm space-y-4" data-id="element-1137">
              <div data-id="element-1138">
                <label htmlFor="full-name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1139">
                  Full Name
                </label>
                <div className="relative" data-id="element-1140">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1141">
                    <UserIcon className="h-5 w-5 text-gray-400" data-id="element-1142" />
                  </div>
                  <input id="full-name" name="full-name" type="text" autoComplete="name" required value={fullName} onChange={e => setFullName(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Full Name" data-id="element-1143" />
                </div>
              </div>
              <div data-id="element-1144">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1145">
                  Email address
                </label>
                <div className="relative" data-id="element-1146">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1147">
                    <MailIcon className="h-5 w-5 text-gray-400" data-id="element-1148" />
                  </div>
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Email address" data-id="element-1149" />
                </div>
              </div>
              <div data-id="element-1150">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1151">
                  Phone Number
                </label>
                <div className="relative" data-id="element-1152">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1153">
                    <PhoneIcon className="h-5 w-5 text-gray-400" data-id="element-1154" />
                  </div>
                  <input id="phone" name="phone" type="tel" autoComplete="tel" required value={phone} onChange={e => setPhone(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Phone Number" data-id="element-1155" />
                </div>
              </div>
              <div data-id="element-1156">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1157">
                  Password
                </label>
                <div className="relative" data-id="element-1158">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1159">
                    <LockIcon className="h-5 w-5 text-gray-400" data-id="element-1160" />
                  </div>
                  <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="new-password" required value={password} onChange={e => setPassword(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Password" data-id="element-1161" />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1162">
                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-1163">
                      {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-1164" /> : <EyeIcon className="h-5 w-5" data-id="element-1165" />}
                    </button>
                  </div>
                </div>
              </div>
              <div data-id="element-1166">
                <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1167">
                  Confirm Password
                </label>
                <div className="relative" data-id="element-1168">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1169">
                    <LockIcon className="h-5 w-5 text-gray-400" data-id="element-1170" />
                  </div>
                  <input id="confirm-password" name="confirm-password" type={showConfirmPassword ? 'text' : 'password'} autoComplete="new-password" required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Confirm Password" data-id="element-1171" />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1172">
                    <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-1173">
                      {showConfirmPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-1174" /> : <EyeIcon className="h-5 w-5" data-id="element-1175" />}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1176">
              <input id="agree-terms" name="agree-terms" type="checkbox" required checked={agreeTerms} onChange={e => setAgreeTerms(e.target.checked)} className="h-4 w-4 text-pink-700 focus:ring-pink-500 border-gray-300 rounded" data-id="element-1177" />
              <label htmlFor="agree-terms" className="ml-2 block text-sm text-gray-900" data-id="element-1178">
                I agree to the{' '}
                <a href="#" className="font-medium text-pink-700 hover:text-pink-500" data-id="element-1179">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="#" className="font-medium text-pink-700 hover:text-pink-500" data-id="element-1180">
                  Privacy Policy
                </a>
              </label>
            </div>
            <div data-id="element-1181">
              <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent rounded-md text-white bg-pink-700 hover:bg-pink-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500" data-id="element-1182">
                Create Account
              </button>
            </div>
            <div className="text-center" data-id="element-1183">
              <p className="text-sm text-gray-600" data-id="element-1184">
                Already have an account?{' '}
                <Link to="/login" className="font-medium text-pink-700 hover:text-pink-500" data-id="element-1185">
                  Sign in
                </Link>
              </p>
            </div>
          </form>
        </div>
      </main>
      <Footer data-id="element-1186" />
    </div>;
}